<template>
  <TypeAhead
    ref="autocomplete"
    :src="srcComputed"
    placeholder="Por favor ingrese algun parametro"
    searching-text="Buscando..."
    :fetch="fetch"
    :render="render"
    :on-hit="onSelect"
    :get-response="getResponse"
  />
</template>


<script>
import TypeAhead from 'vue2-typeahead'

export default {
  components: { TypeAhead },
  props: {
  },
  data() {
    return {
      entity: null,
    }
  },
  computed: {
    userChoice() {
      return this.$store.state.userChoice;
    },
    srcComputed() {
      return `/api/v1/universal_search?query=:keyword&debt_collection_type=${this.userChoice}`;
    },
  },
  mounted() {
    // console.log(this.$refs.autocomplete);
  },
  methods: {
    fetch(url) {
      return new Promise((resolve) =>
        setTimeout(() => resolve(this.$http(url)), 1000)
      )
    },
    render(items, _vue) {
      let names = []
      items.forEach(element => {
        if (element["type"] === "creditors") {
          names.push(`${element.name} - ${element.company_id} (Acreedor)`)
        } else if (element["type"] === "debtors") {
          names.push(`${element.name} - ${element.debtor_id} (Deudor)`)
        } else if (element["type"] === "debt_collections") {
          names.push(`${element.invoice_id} - ${element.creditor.name} (Factura)`)
        }
      })
      return names
    },
    getResponse(response) {
      let items = response.data.data
      let results = []
      Object.keys(items).forEach(key => {
        items[key].forEach( element => {
          element["type"] = key
          results.push(element)
        })
      });
      return results
    },
    onSelect(item, vue, index) {
      let element = vue.data[index]
      vue.query = item
      if (element["type"] === "creditors") {
          this.$router.push('/apps/' + this.$store.getters['auth/userEntity'] + '/creditor/' + element.company_id)
        } else if (element["type"] === "debtors") {
          this.$router.push('/apps/' + this.$store.getters['auth/userEntity'] + '/debtor/' + element.debtor_id)
        } else if (element["type"] === "debt_collections") {
          this.$router.push('/apps/' + this.$store.getters['auth/userEntity'] + '/debt_collection/' + element.creditor.company_id + '/' + element.invoice_id)
        }
    },
  },
}
</script>


<style>
</style>
